import { FC, ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

interface KioskNonAuthGuardProps {
  children: ReactNode;
}

const KioskNonAuthGuard: FC<KioskNonAuthGuardProps> = ({ children }) => {
  const isLoggedIn = JSON.parse(localStorage.getItem('isLoggedIn') || 'false');

  // If user is not logged in, allow access to public pages
  if (!isLoggedIn) {
    return <>{children}</>;
  }

  // // If user is logged in, redirect to welcome page
  return <Navigate to="/home" replace />;
};

export default KioskNonAuthGuard;
